// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__1-e_W","item":"PaymentsMobile_item__3DDn3","label":"PaymentsMobile_label__iyXrv","amount":"PaymentsMobile_amount__KoTVd"};